import { render, staticRenderFns } from "./HignRegisterNew.vue?vue&type=template&id=63524bc0&"
import script from "./HignRegisterNew.vue?vue&type=script&lang=js&"
export * from "./HignRegisterNew.vue?vue&type=script&lang=js&"
import style0 from "./HignRegisterNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports